import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ClientContactUserVesselModal from "./ClientContactUserVesselModal";
import {
  assignClientToUser,
  createClientUsersMaster,
  getAvailableClients,
  getClientUsersMasterById,
  getCurrentUserName,
  getClientUserApiErrorMessage,
  getUsersApplicableClients,
  isApiSuccess,
  normalizeAvailableClient,
  searchClientUsersMaster,
  unassignClientFromUser,
  updateClientUsersMaster,
} from "../Actions/ClientContactUserAPI";
import { apiRoleToUi, uiRoleToApi } from "../helpers/clientContactUserRole";
import {
  pushWithClientUserNotify,
  showClientUserRouteNotify,
  showClientUserToast,
} from "../helpers/clientContactUserNotify";
import "./UserManagementMaster.css";

class ClientContactUserEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clientUsersMasterId: null,
      userInfo: {
        name: "",
        email: "",
        phone: "",
        role: "",
      },
      applicableClients: [],
      availableClients: [],
      selectedClientId: "",
      activeClient: null,
      showVesselModal: false,
      loading: false,
      saving: false,
      fieldErrors: {
        name: "",
        email: "",
        role: "",
      },
    };
    this.handleUserChange = this.handleUserChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleClientSelectChange = this.handleClientSelectChange.bind(this);
  }

  componentDidMount() {
    const { match, dispatch, t, history, location } = this.props;
    const userId = match.params.id;
    const isCreateMode = !userId;

    showClientUserRouteNotify(history, location);

    dispatch({
      type: "SubBannerTitle",
      data: (
        isCreateMode
          ? t("ClientContactUserManagementContent.AddClientUser")
          : t("ClientContactUserManagementContent.EditClientUser")
      ).toUpperCase(),
    });
    dispatch({ type: "ShowSidePan", data: false });

    if (!isCreateMode) {
      this.loadUser(userId);
    }
  }

  loadUser(clientUsersMasterId) {
    this.setState({ loading: true, clientUsersMasterId: Number(clientUsersMasterId) });

    Promise.all([
      getClientUsersMasterById(clientUsersMasterId),
      getUsersApplicableClients(clientUsersMasterId),
    ])
      .then(([masterResponse, clientsResponse]) => {
        const master = masterResponse.data || {};
        const applicableClients = (clientsResponse.data || []).map((client) => ({
          usersApplicableClientId: client.usersApplicableClientId,
          clientId: client.clientId,
          clientName: client.clientName,
          vesselCount: client.vesselCount || 0,
        }));

        this.setState(
          {
            userInfo: {
              name: master.name || "",
              email: master.email || "",
              phone: master.phone || "",
              role: apiRoleToUi(master.roleName),
            },
            applicableClients,
            loading: false,
          },
          () => this.loadAvailableClients()
        );
      })
      .catch(() => {
        this.setState({ loading: false });
        showClientUserToast.error(this.props.t("CommonText.500ErrorMessage"));
      });
  }

  reloadApplicableClients() {
    const { clientUsersMasterId } = this.state;
    if (!clientUsersMasterId) {
      return;
    }

    getUsersApplicableClients(clientUsersMasterId).then((response) => {
      const applicableClients = (response.data || []).map((client) => ({
        usersApplicableClientId: client.usersApplicableClientId ?? client.UsersApplicableClientId,
        clientId: client.clientId ?? client.ClientId,
        clientName: client.clientName ?? client.ClientName,
        vesselCount: client.vesselCount ?? client.VesselCount ?? 0,
      }));
      this.setState({ applicableClients }, () => this.loadAvailableClients());
    });
  }

  loadAvailableClients() {
    const { clientUsersMasterId } = this.state;
    if (!clientUsersMasterId) {
      return;
    }

    getAvailableClients(clientUsersMasterId, "")
      .then((response) => {
        this.setState({
          availableClients: (response.data || []).map(normalizeAvailableClient),
          selectedClientId: "",
        });
      })
      .catch(() => {
        this.setState({ availableClients: [], selectedClientId: "" });
      });
  }

  handleClientSelectChange(e) {
    const selectedClientId = e.target.value;
    if (!selectedClientId) {
      return;
    }

    const client = this.state.availableClients.find(
      (item) => String(item.clientId) === String(selectedClientId)
    );

    if (client) {
      this.setState({ selectedClientId: "" });
      this.addClient(client);
    }
  }

  isCreateMode() {
    return !this.props.match.params.id;
  }

  handleUserChange(e) {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      userInfo: {
        ...prevState.userInfo,
        [name]: value,
      },
      fieldErrors: {
        ...prevState.fieldErrors,
        [name]: "",
      },
    }));
  }

  isValidEmail(email) {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test((email || "").trim());
  }

  validateForm(t) {
    const { userInfo } = this.state;
    const fieldErrors = {
      name: "",
      email: "",
      role: "",
    };

    if (!userInfo.name || !userInfo.name.trim()) {
      fieldErrors.name = t("ErrorMessage.RequiredMsg");
    }

    if (!userInfo.email || !userInfo.email.trim()) {
      fieldErrors.email = t("ErrorMessage.RequiredMsg");
    } else if (!this.isValidEmail(userInfo.email)) {
      fieldErrors.email = t("ErrorMessage.InvalidMsg");
    }

    if (!userInfo.role) {
      fieldErrors.role = t("ErrorMessage.RequiredMsg");
    }

    const hasErrors = Object.values(fieldErrors).some(Boolean);
    this.setState({ fieldErrors }, () => {
      if (hasErrors) {
        const firstInvalidField = document.querySelector(
          ".user-module-master.um-edit-page .um-filter-field.has-error"
        );
        if (firstInvalidField) {
          firstInvalidField.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    });

    return !hasErrors;
  }

  handleCancel() {
    this.props.history.push("/Home/Management/Users/ClientContacts");
  }

  findCreatedMasterId(email) {
    return searchClientUsersMaster({
      Name: "",
      Email: email,
      Phone: "",
      Role: "",
      PageNumber: 1,
      PageSize: 1,
    }).then((response) => {
      const users = response.data?.data || [];
      const match = users.find(
        (user) => (user.email || "").toLowerCase() === email.toLowerCase()
      );
      return match?.clientUsersMasterId || null;
    });
  }

  handleSave() {
    const { t, history } = this.props;
    const { userInfo, clientUsersMasterId } = this.state;

    if (!this.validateForm(t)) {
      return;
    }

    const payload = {
      role: uiRoleToApi(userInfo.role),
      name: userInfo.name.trim(),
      email: userInfo.email.trim(),
      phone: userInfo.phone || "",
      address: "",
      createdBy: getCurrentUserName(),
      modifiedBy: getCurrentUserName(),
    };

    this.setState({ saving: true });

    if (this.isCreateMode()) {
      createClientUsersMaster({
        ...payload,
        createdBy: getCurrentUserName(),
      })
        .then((response) => {
          if (!isApiSuccess(response.data)) {
            this.setState({ saving: false });
            showClientUserToast.error(
              getClientUserApiErrorMessage(response.data, t("CommonText.500ErrorMessage"))
            );
            return;
          }

          return this.findCreatedMasterId(payload.email).then((masterId) => {
            this.setState({ saving: false });
            if (masterId) {
              pushWithClientUserNotify(
                history,
                `/Home/Management/Users/ClientContacts/Edit/${masterId}`,
                t("ClientContactUserManagementContent.UserAddedAssignClients")
              );
              return;
            }
            pushWithClientUserNotify(
              history,
              "/Home/Management/Users/ClientContacts",
              t("CommonText.CommonAdd")
            );
          });
        })
        .catch(() => {
          this.setState({ saving: false });
          showClientUserToast.error(t("CommonText.500ErrorMessage"));
        });
      return;
    }

    updateClientUsersMaster({
      clientUsersMasterId,
      role: payload.role,
      name: payload.name,
      email: payload.email,
      phone: payload.phone,
      address: "",
      isDeleted: false,
      modifiedBy: getCurrentUserName(),
    })
      .then((response) => {
        this.setState({ saving: false });
        if (isApiSuccess(response.data)) {
          pushWithClientUserNotify(
            history,
            "/Home/Management/Users/ClientContacts",
            t("CommonText.CommonUpdate")
          );
          return;
        }
        showClientUserToast.error(
          getClientUserApiErrorMessage(response.data, t("CommonText.500ErrorMessage"))
        );
      })
      .catch(() => {
        this.setState({ saving: false });
        showClientUserToast.error(t("CommonText.500ErrorMessage"));
      });
  }

  addClient(client) {
    const { clientUsersMasterId } = this.state;
    const { t } = this.props;

    if (!clientUsersMasterId) {
      showClientUserToast.error(t("ClientContactUserManagementContent.SaveUserBeforeClients"));
      return;
    }

    assignClientToUser({
      clientUsersMasterId,
      clientId: client.clientId,
      createdBy: getCurrentUserName(),
    })
      .then((response) => {
        if (isApiSuccess(response.data)) {
          this.setState({ selectedClientId: "" });
          this.reloadApplicableClients();
          return;
        }
        showClientUserToast.error(response.data || t("CommonText.500ErrorMessage"));
      })
      .catch(() => {
        showClientUserToast.error(t("CommonText.500ErrorMessage"));
      });
  }

  removeClient(client) {
    const { t } = this.props;

    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            unassignClientFromUser({
              usersApplicableClientId: client.usersApplicableClientId,
              modifiedBy: getCurrentUserName(),
            })
              .then((response) => {
                if (response.data === "Deleted") {
                  this.reloadApplicableClients();
                  return;
                }
                showClientUserToast.error(response.data || t("CommonText.500ErrorMessage"));
              })
              .catch(() => {
                showClientUserToast.error(t("CommonText.500ErrorMessage"));
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
        },
      ],
    });
  }

  openVesselModal(client) {
    this.setState({
      activeClient: client,
      showVesselModal: true,
    });
  }

  saveVessels(vesselCount) {
    const { t } = this.props;
    this.setState(
      {
        applicableClients: this.state.applicableClients.map((client) =>
          client.usersApplicableClientId === this.state.activeClient?.usersApplicableClientId
            ? { ...client, vesselCount }
            : client
        ),
        showVesselModal: false,
        activeClient: null,
      },
      () => {
        showClientUserToast.success(t("CommonText.CommonUpdate"));
        this.reloadApplicableClients();
      }
    );
  }

  closeVesselModal() {
    this.setState({
      showVesselModal: false,
      activeClient: null,
    });
  }

  renderFormField(label, name, placeholder, iconClass, type = "text", required = false, disabled = false) {
    const error = this.state.fieldErrors[name];

    return (
      <div className={`col-lg-3 col-md-6 um-filter-field${error ? " has-error" : ""}`}>
        <label className="form-label">
          {label}
          {required ? <span className="um-required">*</span> : null}
        </label>
        <div className={`um-input-shell${error ? " is-invalid" : ""}`}>
          <span className="um-input-icon">
            <i className={`fa ${iconClass}`} aria-hidden="true"></i>
          </span>
          <input
            className="form-control"
            type={type}
            name={name}
            placeholder={placeholder}
            value={this.state.userInfo[name]}
            onChange={this.handleUserChange}
            disabled={disabled}
            aria-invalid={error ? "true" : "false"}
            aria-describedby={error ? `${name}-error` : undefined}
          />
        </div>
        {error ? (
          <div className="um-field-error" id={`${name}-error`} role="alert">
            <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
            <span>{error}</span>
          </div>
        ) : null}
      </div>
    );
  }

  renderRoleField(t, disabled = false) {
    const error = this.state.fieldErrors.role;

    return (
      <div className={`col-lg-3 col-md-6 um-filter-field${error ? " has-error" : ""}`}>
        <label className="form-label">
          {t("ClientContactUserManagementContent.Role")}
          <span className="um-required">*</span>
        </label>
        <div className={`um-input-shell${error ? " is-invalid" : ""}`}>
          <span className="um-input-icon">
            <i className="fa fa-briefcase" aria-hidden="true"></i>
          </span>
          <div className="um-select-wrap">
            <select
              className="form-control um-select"
              name="role"
              value={this.state.userInfo.role}
              onChange={this.handleUserChange}
              disabled={disabled}
              aria-invalid={error ? "true" : "false"}
              aria-describedby={error ? "role-error" : undefined}
            >
              <option value="">
                {t("ClientContactUserManagementContent.AllRoles")}
              </option>
              <option value="FM">
                {t("ClientContactUserManagementContent.FM")}
              </option>
              <option value="TSI">
                {t("ClientContactUserManagementContent.TSI")}
              </option>
              <option value="TE">
                {t("ClientContactUserManagementContent.TE")}
              </option>
            </select>
            <i className="fa fa-chevron-down um-select-chevron" aria-hidden="true"></i>
          </div>
        </div>
        {error ? (
          <div className="um-field-error" id="role-error" role="alert">
            <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
            <span>{error}</span>
          </div>
        ) : null}
      </div>
    );
  }

  renderApplicableClients(t) {
    const { applicableClients, availableClients, selectedClientId, clientUsersMasterId } = this.state;
    const canManageClients = !!clientUsersMasterId;

    return (
      <div className="um-section">
        <div className="um-section-header">
          <h5 className="um-section-title">
            <i className="fa fa-building um-section-title-icon" aria-hidden="true"></i>
            {t("ClientContactUserManagementContent.ApplicableClients")}
          </h5>
        </div>
        <div className="um-section-body">
          {!canManageClients ? (
            <div className="um-empty-state">
              {t("ClientContactUserManagementContent.SaveUserBeforeClients")}
            </div>
          ) : (
            <>
              <div className="row">
                <div className="col-lg-6 col-md-8 um-filter-field">
                  <label className="form-label">
                    {t("ClientContactUserManagementContent.ClientName")}
                  </label>
                  <div className="um-input-shell">
                    <span className="um-input-icon">
                      <i className="fa fa-search" aria-hidden="true"></i>
                    </span>
                    <select
                      className="form-control um-client-select"
                      value={selectedClientId}
                      onChange={this.handleClientSelectChange}
                    >
                      <option value="">
                        {t("ClientContactUserManagementContent.SelectClient")}
                      </option>
                      {availableClients.map((client) => (
                        <option key={client.clientId} value={client.clientId}>
                          {client.clientName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="um-client-table-wrap">
                {applicableClients.length ? (
                  <>
                    <div className="um-client-table-header" aria-hidden="true">
                      <span className="um-client-col-name">
                        {t("ClientContactUserManagementContent.ClientName")}
                      </span>
                      <span className="um-client-col-vessels">
                        {t("ClientContactUserManagementContent.VesselsAssigned")}
                      </span>
                      <span className="um-client-col-actions">
                        {t("ClientContactUserManagementContent.Actions")}
                      </span>
                    </div>
                    <div className="um-client-table-body">
                      {applicableClients.map((client) => (
                        <div key={client.usersApplicableClientId} className="um-client-row">
                          <div className="um-client-row-name">
                            <span className="um-client-row-icon">
                              <i className="fa fa-building" aria-hidden="true"></i>
                            </span>
                            <button
                              type="button"
                              className="um-client-row-name-btn"
                              onClick={() => this.openVesselModal(client)}
                            >
                              {client.clientName}
                            </button>
                          </div>
                          <div className="um-client-row-vessels">
                            <button
                              type="button"
                              className="um-client-vessel-badge"
                              onClick={() => this.openVesselModal(client)}
                            >
                              {client.vesselCount}{" "}
                              {t("ClientContactUserManagementContent.Vessels")}
                            </button>
                          </div>
                          <div className="um-client-row-actions">
                            <button
                              type="button"
                              className="um-action-btn"
                              onClick={() => this.openVesselModal(client)}
                              aria-label={t("IntervelScreen.Edit")}
                            >
                              <i className="fa fa-pencil" aria-hidden="true"></i>
                            </button>
                            <button
                              type="button"
                              className="um-action-btn um-delete-btn"
                              onClick={() => this.removeClient(client)}
                              aria-label={t("content.Delete")}
                            >
                              <i className="fa fa-trash" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="um-empty-state">
                    {t("ClientContactUserManagementContent.NoClientsConfigured")}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const { activeClient, showVesselModal, loading, saving } = this.state;
    const isCreateMode = this.isCreateMode();

    if (loading) {
      return (
        <div className="full-height user-module-master um-edit-page">
          <div className="um-empty-state pt-5">Loading...</div>
        </div>
      );
    }

    return (
      <div className="full-height user-module-master um-edit-page">
        <div className="pt-3">
          <button
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue um-return-btn"
            onClick={this.handleCancel}
            style={{ display: "inline-flex", alignItems: "center" }}
          >
            <span style={{ marginTop: "-1px" }}>&larr;</span>
            {t("CommonText.Return")}
          </button>

          <div className="um-section">
            <div className="um-section-header">
              <h5 className="um-section-title">
                <i className="fa fa-user um-section-title-icon" aria-hidden="true"></i>
                {t("EquipmentManagementScreenContent.BasicInformation")}
              </h5>
            </div>
            <div className="um-section-body">
              <div className="row">
                {this.renderFormField(
                  t("EquipmentManagementScreenContent.Name"),
                  "name",
                  t("EquipmentManagementScreenContent.Name"),
                  "fa-user-circle",
                  "text",
                  true
                )}
                {this.renderFormField(
                  t("ServicedByScreenContent.Email"),
                  "email",
                  t("ServicedByScreenContent.Email"),
                  "fa-envelope-o",
                  "email",
                  true
                )}
                {this.renderFormField(
                  t("ClientManagementScreenContent.Phone"),
                  "phone",
                  t("ClientManagementScreenContent.Phone"),
                  "fa-phone"
                )}
                {this.renderRoleField(t)}
              </div>
            </div>
          </div>

          {this.renderApplicableClients(t)}

          {saving ? (
            <div className="um-save-status" role="status" aria-live="polite">
              <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
              <span>
                {isCreateMode
                  ? t("ClientContactUserManagementContent.AddingUser")
                  : t("ClientContactUserManagementContent.UpdatingUser")}
              </span>
            </div>
          ) : null}

          <div className={`um-form-actions${saving ? " is-saving" : ""}`}>
            <button
              type="button"
              className="btn btn-primary text-uppercase um-btn um-btn-primary"
              onClick={this.handleSave}
              disabled={saving}
            >
              {saving ? (
                <>
                  <i className="fa fa-circle-o-notch fa-spin um-btn-spinner" aria-hidden="true"></i>
                  {isCreateMode
                    ? t("ClientContactUserManagementContent.AddingUser")
                    : t("ClientContactUserManagementContent.UpdatingUser")}
                </>
              ) : (
                <>
                  {isCreateMode
                    ? t("ShipManagementContent.Add")
                    : t("EquipmentServiceTypes.Update")}
                </>
              )}
            </button>
            <button
              type="button"
              className="btn btn-light text-uppercase um-btn um-btn-secondary"
              onClick={this.handleCancel}
              disabled={saving}
            >
              {t("ComplianceandBudgetScreen.Cancel")}
            </button>
          </div>
        </div>

        <ClientContactUserVesselModal
          show={showVesselModal}
          clientName={activeClient ? activeClient.clientName : ""}
          usersApplicableClientId={
            activeClient ? activeClient.usersApplicableClientId : null
          }
          onSave={(vesselCount) => this.saveVessels(vesselCount)}
          onClose={() => this.closeVesselModal()}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ClientContactUserDetails:
      state.MasterScreenReducer.ClientContactUserDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientContactUserEdit))
);
